<template>
  <div
    :class="['form-group', 'ob1-promotional-code', 'flex-nowrap', { 'form-group-inverse': darkMode }]"
    data-ob1-component="PromotionalCode">
    <div class="ob1-promotional-code-content">
      <wptv-alert
        :type="'success'"
        :message="message" />
    </div>

    <promotional-code-button-cancel
      :dark-mode="darkMode"
      :label="cancelButtonLabel"
      :action-cb="onCancel" />
  </div>
</template>

<script>
import WptvAlert from '../../alert/Alert'
import PromotionalCodeButtonCancel from './promotionalCodeButtonCancel/PromotionalCodeButtonCancel'

export default {
  name: 'PromotionalCodeSuccess',
  components: {
    WptvAlert,
    PromotionalCodeButtonCancel
  },
  props: {
    message: {
      type: String,
      required: true
    },
    cancelButtonLabel: {
      type: String,
      required: true
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onCancel () {
      this.$emit('cancel')
    }
  }
}
</script>
